import {accountMovement} from "./es/accountMovement";
import {balanceBonus} from "./es/balanceBonus";
import {bankDeposit} from "./es/bankDeposit";
import {baseModalTitles} from "./es/baseModalTitles";
import {breadcrumbs} from "./es/breadcrumbs";
import {changePassword} from "./es/changePassword";
// import accounts from "./es/accounts";
import {contact} from "./es/contact";
import {cookieConsent} from "./es/cookieConsent";
import {currency} from "./es/currency";
import {deleteAccount} from "./es/deleteAccount";
import {dropdownMenu} from "./es/dropdownMenu";
import {errorBoundary} from "./es/errorBoundary";
import {floatBtn} from "./es/floatBtn";
import {floatingMenu} from "./es/floatingMenu";
import {footer} from "./es/footer";
import {gameFeed} from "./es/gameFeed";
import {games} from "./es/games";
import {homeBtnMoneyHandler} from "./es/homeBtnMoneyHandler";
import {homeModalSessionInfo} from "./es/homeModalSessionInfo";
import {identity} from "./es/identity";
import {inviteFriend} from "./es/inviteFriend";
import {loginModal} from "./es/loginModal";
import {lottery} from "./es/lottery";
import {mobilePayment} from "./es/mobilePayment";
import {news} from "./es/news";
import {notificationDrawer} from "./es/notificationDrawer";
import {notifications} from "./es/notifications";
import {promoBanners} from "./es/promoBanners";
import {quiniela} from "./es/quiniela";
import {raffle} from "./es/raffle";
import {registrationForm} from "./es/registrationForm";
import {sideNavbar} from "./es/sideNavbar";
import {socialNotifications} from "./es/socialNotifications";
import {socialSelector} from "./es/socialSelector";
import {contactSupport} from "./es/support";
import {TOS} from "./es/TOS";
import {testimonials} from "./es/testimonials";
import {transactionTitles} from "./es/transactionTitles";
import {transferSteps} from "./es/transferSteps";
import {userProfile} from "./es/userProfile";
import {wallet} from "./es/wallet";
import {withdrawalSteps} from "./es/widthdrawalSteps";

const es = {
  // ...accounts,
  ...contact,
  ...cookieConsent,
  ...contactSupport,
  ...bankDeposit,
  ...currency,
  ...sideNavbar,
  ...dropdownMenu,
  ...registrationForm,
  ...identity,
  ...userProfile,
  ...floatBtn,
  ...withdrawalSteps,
  ...homeBtnMoneyHandler,
  ...transferSteps,
  ...wallet,
  ...inviteFriend,
  ...changePassword,
  ...mobilePayment,
  ...accountMovement,
  ...transactionTitles,
  ...baseModalTitles,
  ...footer,
  ...notificationDrawer,
  ...notifications,
  ...deleteAccount,
  ...TOS,
  ...lottery,
  ...raffle,
  ...balanceBonus,
  ...loginModal,
  ...errorBoundary,
  ...homeModalSessionInfo,
  ...games,
  ...gameFeed,
  ...breadcrumbs,
  ...floatingMenu,
  ...socialSelector,
  ...promoBanners,
  ...socialNotifications,
  ...testimonials,
  ...news,
  noDataAvailable: "No hay datos disponibles",
  loading: "Cargando...",
  homeDisplaySportsTitle: "APUESTAS DEPORTIVAS",
  homeDisplaySportsSubtitle: "Juega en las mejores ligas del mundo",
  homeDisplayContestChallengeTitle: "CONCURSO - Desafío del más allá",
  latestWinners: "Últimos Ganadores",
  homeDisplayTopGamesTitle: "Los 10 Más Jugados!",
  homeDisplayAllBtn: "Ver Todos",
  homeDisplayLoginBtn: "Iniciar Sesión",
  homeDisplayRegisterBtn: "Registrarse",
  homeDisplayLiveGames: "Proximos partidos",
  homeDisplayLiveGamesSubtitle: "Apuesta con las mejores cuotas",
  homeDisplayFootball: "Fútbol",
  homeDisplayTennis: "Tenis",
  homeDisplayBasketball: "Baloncesto",
  homeDisplayVolleyball: "Voleibol",
  homeDisplayEventRules: "Reglas del Evento",

  homeDisplayModalTitle: "Promoción",
  homeDisplayModalClose: "Cerrar",
  homeModalSessionInfoAtTime: "Inicio de sesión a las ",
  referralMessage: "¡Únete a AYG y disfruta de beneficios exclusivos! Regístrate usando mi enlace de referencia ",
  referralMessageSlots: "Regístrate aquí y recibe 10 rodadas gratis en tragamonedas. ",
  referralMessageSports: "Crea tu cuenta y obtén un bono exclusivo para apostar en tu deporte favorito. ",
  referralMessageBingo: "Crea tu cuenta y recibe cartones gratis. ",
  referralMessageCasino: "Crea tu cuenta y recibe fichas gratis para el casino en vivo. ",
  selectMessageType: "Selecciona tipo de mensaje",
  messageTypeGeneral: "General",
  messageTypeSlots: "Slots",
  messageTypeSports: "Deportes",
  messageTypeBingo: "Bingo",
  messageTypeCasino: "Casino",
  messagePreview: "Vista previa del mensaje",
  copy: "Copiar",
  share: "Compartir",
  scanQR: "Escanear QR",
  scanQRText: "Escanea este código QR para referir a un amigo",
  copyQR: "Copiar QR",
  downloadQR: "Descargar QR",
  shareQR: "Compartir QR",
  qrCopied: "¡Código QR copiado al portapapeles!",
  qrCopyFailed: "Error al copiar el código QR. Por favor, intenta descargarlo.",
  recentReferrals: "Referidos Recientes",
  referralProgram: "Programa de Referidos",
  youReferralStatus: "Tu estado de referido",
  sharedYourLink:
    "Puedes compartir tu enlace de referido copiándolo y enviándolo o compartiéndolo en tus redes sociales",
  referralEarnings: "Ganancias por Referidos",
  referralSummary: "Resumen de Referidos",
  yourReferrals: "Tus Referidos",
  yourReferralsEarned: "Tus Ganancias por Referidos",
  yourReferralsPendingEarned: "Tus Ganancias Pendientes por Referidos",
  yourReferralLink: "Tu enlace",
  qrCode: "Código QR",
  joinedDate: "Fecha de Registro",
  status: "Estado",
  reward: "Recompensa",
  depositDate: "Fecha de Depósito",
  active: "Activo",
  inactive: "Inactivo",
  noReferralsFound: "No se encontraron referidos recientes.",
  totalReferrals: "Total de Referidos",
  activeReferrals: "Referidos Activos",
  hasDeposited: "Ha Depositado",
  yes: "Sí",
  no: "No",
  date: "Fecha",
  pending: "Pendiente",
  paid: "Pagado",
  recentEarnings: "Ganancias Recientes",
  noCommissionsYet: "No hay comisiones aún",
  commission: "comisión",
  totalCommission: "Comisión Total",
  forgotReferralCode: "¿Olvidaste agregar el código de referido en tu perfil?",
  clickHere: "Haz Click Aquí",
  referralCodePlaceholder: "Ingresa tu código de referido",
  send: "Enviar",
  sending: "Enviando...",
  referralCodeAppliedSuccess: "¡Código de referencia aplicado exitosamente!",
  invalidOrInactiveReferralCode: "El código de referencia es inválido o inactivo",
  cashbackTitle: "Cashback Total 13%",
  cashbackDesc: "Cada lunes recibe el 13% de todo lo jugado. ¡Todos los juegos!",
  cashbackActive: "Activo",
  cashbackPayday: "¡Día de pago!",
  cashbackNextMonday: "Próximo lunes",
  cashbackBannerAria: "Promoción Cashback 13% — Cada lunes",
  registerPromoTag: "Promo registro",
  registerPromoTitle: "Regístrate y gana giros gratis",
  registerPromoDesc: "Por cada 40 Bs que deposites en tu primer depósito te damos un giro de cortesía.",
  registerPromoCta: "Regístrate",
  registerPromoAria: "Promoción de registro — Giros gratis en tu primer depósito",
  mondaySpinsTag: "Todos los lunes",
  mondaySpinsTagToday: "¡Hoy es lunes!",
  mondaySpinsTitle: "Todos los lunes giros gratis",
  mondaySpinsDesc: "Por cada 40 Bs que deposites en el primer depósito del día te damos un giro de cortesía.",
  mondaySpinsNextMonday: "Próximo lunes",
  mondaySpinsDeposit: "Depositar",
  mondaySpinsAria: "Promoción lunes — Giros gratis cada lunes",
  dailySpinsTitle: "Gira y gana doble",
  dailySpinsDesc:
    "De lunes a lunes excepto jueves por cada giro que hagas entre las 8 y las 9 pm te damos un giro de cortesía.",
  dailySpinsTag: "Todos los días menos los jueves",
  dailySpinsNextActive: "Próximo activo en",
  homeHeroTagPromo: "Promo",
  homeHeroTagNew: "Nueva Movida",
  homeHeroTagDrop: "Drop",
  homeHeroTagRace: "Race",
  homeHeroTagTournament: "Torneo",
  miniGamesTitle: "Mini Juegos",
  miniGamesViewAll: "Ver todos",
  miniGamesCarouselAria: "Carrusel de mini juegos de casino",
  installPromptTitle: "Instala {{brand}} App",
  installPromptAndroid: "Instala {{brand}} App en tu dispositivo Android",
  installPromptIos: "Instala {{brand}} App en tu dispositivo iOS",
  installPromptDesktop: "Instala {{brand}} App en tu computadora",
  installPromptBenefit: "Así tendrás acceso al mejor entretenimiento en tu dispositivo.",
  installPromptInstall: "Instalar",
  installPromptLater: "Más tarde",
  categoryUnavailableTag: "Próximamente",
  categoryUnavailableTitle: "Estamos mejorando la experiencia de esta categoría",
  categoryUnavailableTitleNamed: "Estamos mejorando la experiencia de {{category}}",
  categoryUnavailableMessage:
    "Esta sección estará disponible muy pronto. Estamos trabajando para ofrecerte una mejor experiencia. Gracias por tu paciencia.",
  categoryUnavailableBack: "Volver al inicio",
  categoryUnavailableExplore: "Explorar otros juegos",
  ...quiniela,

  // SEO / titulo del documento (consumido por useDynamicTitle)
  "meta.tagline": "Hoy te puede tocar a ti - Tu plataforma de apuestas en línea",
  "meta.description": "Tu plataforma de apuestas en línea. Hoy te puede tocar a ti. Juega y apuesta con nosotros.",
};
export default es;
